/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExportRequestTagOntology } from '../../models/export-request-tag-ontology';

export interface GetExportRequestAnalogicOntology$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected ontology
 */
  ontologyUid: string;
}

export function getExportRequestAnalogicOntology(http: HttpClient, rootUrl: string, params: GetExportRequestAnalogicOntology$Params, context?: HttpContext): Observable<StrictHttpResponse<ExportRequestTagOntology>> {
  const rb = new RequestBuilder(rootUrl, getExportRequestAnalogicOntology.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('ontologyUid', params.ontologyUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExportRequestTagOntology>;
    })
  );
}

getExportRequestAnalogicOntology.PATH = '/export-request/{uid}/ontology/analogic/{ontologyUid}';
